export default "__VITE_ASSET__1a0c6315__"